import { useChartContext } from '@/components/Chart/context/ChartContext';
import ExportButton from '@/components/Chart/ExportButton';
import type { ChartType } from '@/components/Chart/types/highcharts';
import type { SymbolKey } from '@/entities/symbol';
import { useSelectedSymbolsActions } from '@/features/DataHub/hooks';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { openExportDrawer } from '@/slices/drawerSlice';
import { setExport } from '@/slices/exportSlice';

const ExportChartButton = ({
  disabled = false,
  graphType,
  metadata
}: {
  graphType: ChartType;
  disabled?: boolean;
  metadata?: Record<string, string>;
}) => {
  const { chartSeries } = useChartContext();

  const dispatch = useAppDispatch();
  const { addSelectedSymbols } = useSelectedSymbolsActions();
  const exportSelection = () => {
    if (chartSeries) {
      const selectedSymbols: SymbolKey[] = chartSeries.map(series => {
        const custom = series.custom;
        return {
          Code: custom.Code,
          Period: custom.Period || '',
          PeriodType: custom.PeriodType,
          TimeRef: custom.TimeRef,
          transactionDate: custom.transactionDate
        };
      });

      dispatch(openExportDrawer({ showHistory: false }));
      dispatch(setExport({ exportType: graphType || 'spot', from: metadata?.from }));
      addSelectedSymbols(selectedSymbols);
    }
  };

  return (
    <ExportButton
      disabled={disabled}
      handleClick={exportSelection}
      title='Export chart'
    />
  );
};

export default ExportChartButton;
